import React from 'react';
import { Button, Flex, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export const RecommendationsControls = () => {
    const navigate = useNavigate();

    const handleAddRecommendation = () => {
        navigate('create');
    };

    return (
        <Flex gap={16} vertical justify={'space-between'}>
            <Title style={{ margin: 0 }} level={4}>
                История рекомендаций
            </Title>
            <Flex gap={8}>
                <Button type={'primary'} onClick={handleAddRecommendation}>
                    Добавить рекомендацию
                </Button>
            </Flex>
        </Flex>
    );
};
